import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { listPendingLeaves, decideLeave } from '../lib/db.js';
import { useAuth } from '../lib/auth.jsx';
import { StatusBar } from '../components/StatusBar.jsx';
import { BottomNav } from '../components/BottomNav.jsx';
import { thaiDate } from '../lib/format.js';

const LEAVE_ICON = { sick: '🤒', personal: '📄', vacation: '🏖', maternity: '👶', spouse_birth: '👶' };

export function LeaveApprovals() {
  const { appUser } = useAuth();
  const nav = useNavigate();
  const [rows, setRows] = useState(null);
  const [err, setErr] = useState('');
  const [flash, setFlash] = useState('');

  useEffect(() => {
    listPendingLeaves().then(setRows).catch((e) => { setErr(e.message); setRows([]); });
  }, []);

  async function decide(r, approve) {
    try {
      await decideLeave(r.id, approve, appUser?.id);
      setRows((prev) => prev.filter((x) => x.id !== r.id));
      setFlash(`${approve ? 'อนุมัติ' : 'ไม่อนุมัติ'} — ${name(r)} · บันทึกผู้ตัดสิน + audit`);
      setTimeout(() => setFlash(''), 2600);
    } catch (e) { setErr(e.message); }
  }

  return (
    <div className="phone">
      <StatusBar />
      <section className="screen">
        <button className="back" onClick={() => nav(-1)}>‹ กลับ</button>
        <div className="title-row">
          <div><div className="eyebrow">คำขอลา</div><h1 className="page">รออนุมัติ</h1></div>
          <span className="glyph">🗓</span>
        </div>

        {err && <p className="err">{err}</p>}
        {!rows && <div className="center"><div className="spinner" /></div>}
        {rows && (
          <>
            <div className="hero"><div className="num">{rows.length}</div><div className="sub">คำขอที่รอคุณตัดสินใจ</div></div>
            {flash && <div className="leave-note"><b>{flash}</b></div>}
            <hr className="hr" />
            {rows.length === 0 && <p className="muted">ไม่มีคำขอค้าง 👍</p>}
            {rows.map((r) => {
              const code = leaveCode(r);
              const cert = needsCert(r);
              return (
                <div className="card" key={r.id}>
                  <div className="row" style={{ paddingTop: 0, border: 0 }}>
                    <div className="ic">{LEAVE_ICON[code] || '🗓'}</div>
                    <div className="main">
                      <div className="l1">{name(r)} — {leaveName(r)}</div>
                      <div className="l2">{thaiDate(r.start_date)}{r.end_date !== r.start_date ? `–${thaiDate(r.end_date)}` : ''} · {r.days} วัน</div>
                    </div>
                    {(r.medical_cert || r.medical_cert_url)
                      ? <span className="tag ok">มีใบรับรองแพทย์</span>
                      : <span className="tag pend">รอ</span>}
                  </div>
                  {r.reason && <div className="note" style={{ marginTop: 6 }}>เหตุผล: {r.reason}</div>}
                  {(code === 'sick' || code === 'maternity' || code === 'spouse_birth') && (
                    <div className="leave-note">
                      ✓ สิทธิตามกฎหมาย — ระบบจะ <b>ไม่นับเป็นความผิด</b> ในสถิติ
                      {code === 'spouse_birth' ? ' · พ.ร.บ.9/2568 จ่ายเต็ม ≤15 วัน' : ''}
                    </div>
                  )}
                  {cert && !(r.medical_cert || r.medical_cert_url) && (
                    <div className="note" style={{ marginTop: 8, color: 'var(--warn)' }}>⚠︎ ลา ≥3 วันควรมีใบรับรองแพทย์</div>
                  )}
                  <div className="btn-row">
                    <button className="b-ok" onClick={() => decide(r, true)}>อนุมัติ</button>
                    <button className="b-no" onClick={() => decide(r, false)}>ไม่อนุมัติ</button>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </section>
      <BottomNav />
    </div>
  );
}

const leaveName = (r) => r.name_th || r.leave_types?.name_th || 'ลา';
const leaveCode = (r) => r.code || r.leave_types?.code || '';
const needsCert = (r) => r.days >= 3 && (leaveCode(r) === 'sick');
const name = (r) => r.emp_name || (r.employees ? (r.employees.nickname || r.employees.first_name) : '');
